import { InputBase, styled } from '@mui/material';

export const LockedInputSpan = styled('span')(() => ({
  display: 'block',
  width: '100%',
}));

export const LockedInputStyled = styled(InputBase)(({ theme }) => ({
  width: '100%',

  '& .MuiInputBase-input': {
    position: 'relative',
    borderBottom: `solid 1px ${theme.palette.colors.borderLine}`,
    fontSize: 12,
    width: '100%',
    color: theme.palette.colors.onSecondaryAndDetailBackground,
    fontWeight: 500,
    padding: '8px 0 7px 8px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',

    '&.Mui-disabled': {
      WebkitTextFillColor: theme.palette.colors.onSecondaryAndDetailBackground,
    },
  },
}));
